import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-image-modal',
  template: `
    <div class="image-modal-wrapper">
      <div class="image-modal-header">
        <div class="header-info">
          <h3>{{ data.imageTitle }}</h3>
          <div class="image-details">
            <span class="detail-item">{{ 'Tamaño: ' + data.imageSize }}</span>
            <span *ngIf="data.imageWeightKB" class="detail-item">{{ 'Peso: ' + data.imageWeightKB + 'KB' }}</span>
          </div>
        </div>
        <button mat-icon-button (click)="close()" class="close-button">
          <mat-icon>close</mat-icon>
        </button>
      </div>
      <div class="image-modal-content" 
           (wheel)="onWheel($event)"
           (mousedown)="onMouseDown($event)"
           (mousemove)="onMouseMove($event)"
           (mouseup)="onMouseUp($event)"
           (mouseleave)="onMouseUp($event)">
        <img 
          #imageElement
          [src]="data.imageSrc" 
          [style.transform]="'translate(' + translateX + 'px, ' + translateY + 'px) scale(' + scale + ')'"
          [style.cursor]="isDragging ? 'grabbing' : 'grab'"
          draggable="false"
          class="modal-image"
        />
      </div>
      <div class="image-modal-footer">
        <button mat-raised-button color="primary" (click)="zoomIn()">
          <mat-icon>zoom_in</mat-icon>
          {{ 'Zoom In' }}
        </button>
        <button mat-raised-button color="primary" (click)="zoomOut()">
          <mat-icon>zoom_out</mat-icon>
          {{ 'Zoom Out' }}
        </button>
        <button mat-raised-button color="primary" (click)="resetZoom()">
          <mat-icon>fit_screen</mat-icon>
          {{ 'Reset' }}
        </button>
        <span class="zoom-level">{{ (scale * 100).toFixed(0) }}%</span>
      </div>
    </div>
  `,
  styles: [`
    .image-modal-wrapper {
      display: flex;
      flex-direction: column;
      height: 100%;
      background: #fff;
    }
    .image-modal-header {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 16px;
      border-bottom: 1px solid #e0e0e0;
    }
    .header-info {
      display: flex;
      flex-direction: column;
      gap: 8px;
    }
    .image-modal-header h3 {
      margin: 0;
      font-size: 18px;
      font-weight: 500;
    }
    .image-details {
      display: flex;
      gap: 16px;
      font-size: 14px;
      color: #666;
    }
    .detail-item {
      display: inline-block;
    }
    .close-button {
      color: #666;
    }
    .image-modal-content {
      flex: 1;
      overflow: hidden;
      display: flex;
      align-items: center;
      justify-content: center;
      background: #f5f5f5;
      position: relative;
      cursor: grab;
    }
    .image-modal-content:active {
      cursor: grabbing;
    }
    .modal-image {
      max-width: none;
      max-height: none;
      user-select: none;
      transition: transform 0.1s ease-out;
    }
    .image-modal-footer {
      display: flex;
      justify-content: center;
      align-items: center;
      gap: 12px;
      padding: 16px;
      border-top: 1px solid #e0e0e0;
    }
    .zoom-level {
      margin-left: 16px;
      font-weight: bold;
      color: #666;
    }
  `]
})
export class ImageModalComponent implements OnInit {
  scale = 1;
  translateX = 0;
  translateY = 0;
  isDragging = false;
  startX = 0;
  startY = 0;
  startTranslateX = 0;
  startTranslateY = 0;

  constructor(
    public dialogRef: MatDialogRef<ImageModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { imageSrc: string; imageSize: string; imageTitle: string; imageWeightKB?: number }
  ) {}

  ngOnInit(): void {}

  close(): void {
    this.dialogRef.close();
  }

  zoomIn(): void {
    this.scale = Math.min(this.scale * 1.2, 5);
  }

  zoomOut(): void {
    this.scale = Math.max(this.scale / 1.2, 0.5);
  }

  resetZoom(): void {
    this.scale = 1;
    this.translateX = 0;
    this.translateY = 0;
  }

  onWheel(event: WheelEvent): void {
    event.preventDefault();
    const delta = event.deltaY > 0 ? 0.9 : 1.1;
    this.scale = Math.max(0.5, Math.min(5, this.scale * delta));
  }

  onMouseDown(event: MouseEvent): void {
    if (event.button === 0) {
      this.isDragging = true;
      this.startX = event.clientX;
      this.startY = event.clientY;
      this.startTranslateX = this.translateX;
      this.startTranslateY = this.translateY;
    }
  }

  onMouseMove(event: MouseEvent): void {
    if (this.isDragging) {
      this.translateX = this.startTranslateX + (event.clientX - this.startX);
      this.translateY = this.startTranslateY + (event.clientY - this.startY);
    }
  }

  onMouseUp(event: MouseEvent): void {
    this.isDragging = false;
  }
}
